exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-2b35c561] {\n  margin: 0 0 10px;\n  font-size: 16px;\n  font-weight: 700;\n}\n.title[data-v-2b35c561]:before {\n  content: \"\";\n  width: 4px;\n  height: 16px;\n  display: inline-block;\n  background: #1089ff;\n  vertical-align: middle;\n}", ""]);

// exports
